import React, { useContext, useMemo, useState } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { ManageAncillaryContext } from "../../context/ManageAncillaryContext";
import { AncillaryItem } from "../AncillaryItem";
import { UpdatedAncillaryItem } from "../edit-ancillary-form/EditAncillaryForm";
import { EditAncillarySideForm } from "../edit-ancillary-form/EditAncillarySideForm";

export const EditAncillaryButton: React.FC<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const { updateAncillaryItem } = useContext(ManageAncillaryContext);
    const [isSideFormOpen, setSideFormOpen] = useState<boolean>(false);

    const { ancillaryItems, ancillariesToMerge } = useContext(ManageAncillaryContext);

    const itemToUpdate = useMemo(
        () => ancillaryItems.find((ancillary: AncillaryItem) => ancillary.id === props.itemId),
        [ancillaryItems, props.itemId]
    );

    const mergingInProgress = !!ancillariesToMerge.length;

    const handleClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
        event?.currentTarget.blur();

        setSideFormOpen(true);
    };

    const handleEditAncillarySubmit = (updatedAncillary: UpdatedAncillaryItem) => {
        updateAncillaryItem(updatedAncillary);
        setSideFormOpen(false);
    };

    const closeEditVersionSidebar = () => {
        setSideFormOpen(false);
    };

    return (
        <>
            <EditListButton
                onClick={handleClick}
                disabled={itemToUpdate?.merged || mergingInProgress || props.disabled}
            />
            <EditAncillarySideForm
                onSubmit={handleEditAncillarySubmit}
                onClose={closeEditVersionSidebar}
                isOpen={isSideFormOpen}
                ancillaryToEditId={props.itemId ?? ""}
            />
        </>
    );
};
